import { render, staticRenderFns } from "./AddAnchorTypeDialog.vue?vue&type=template&id=0455903a&scoped=true"
import script from "./AddAnchorTypeDialog.vue?vue&type=script&lang=js"
export * from "./AddAnchorTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddAnchorTypeDialog.vue?vue&type=style&index=0&id=0455903a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0455903a",
  null
  
)

export default component.exports